export interface GrafanaTracking {
  organization: string;
  lobName: string;
  platform: string;
  latencies: Latency[];
  errors: ErrorTrack[];
}

export interface Latency {
  pageName: string;
  entityType: string;
  entityName: string;
  latencyInMilli: number;
  latencyType: string;
}

export interface ErrorTrack {
  pageName: string;
  entityType: string;
  entityName: string;
  errorMessage: string;
  errorCode: number;
}

//PageType should be in sync with BE
export const ENTITY_TYPE = {
  PAGE: 'page',
  API: 'api',
  COMPONENT: 'component',
};

export const NEW_PDT_ERROR_CODES = {
  GENERIC: 9999,
  TOP_LEVEL: 8888,
  LISTING_LOAD_ERROR_CODE: 5001,
  TRAVELLER_ERROR_CODE: 5002,
  THANK_YOU_ERROR_CODE_SUCCESS: 5003,
  THANK_YOU_ERROR_CODE_FAILURE: 5004,
  CONNECTED_TRAVEL_ERROR: 5005,
  LANDING_LOAD_ERROR_CODE: 5006,
  REVIEW_LOAD_ERROR_CODE: 5007,
};

export const GRAFANA_ERROR_CODES = {
  LANDING_PAGE_FECHA_ERROR: 4001,
};

export type EntityType = typeof ENTITY_TYPE[keyof typeof ENTITY_TYPE];

export const PAGE_TYPES = {
  LANDING: 'LANDING',
  COMMON_LANDING: 'COMMON_LANDING',
  LISTING: 'LISTING',
  TRAVELLER: 'TRAVELLER',
};
export type PageType = typeof PAGE_TYPES[keyof typeof PAGE_TYPES];

//PageNames can be anything
export const PAGE = {
  LISTING_V2: 'rails_listing_v2',
  LISTING_V3: 'rails_listing_v3',
  LANDING: 'rails_landing',
  LISTING: 'rails_listing',
  COMMON: 'rails_common',
  COMMON_LANDING: 'rails_bus_common_landing',
  TRAVELLER: 'rails_traveller',
  REVIEW: 'rails_review',
  THANK_YOU: 'rails_thankyou',
  IRCTC_WEB_PAGE: 'irctc_web_page',
  LOB_GENERIC: 'rails_generic',
  RIS: 'rails_ris',
  ANY: 'rails_any',
};
export type PageNames = typeof PAGE[keyof typeof PAGE];
